import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
} from 'ag-grid-community';
import { isEmpty } from 'lodash';
import {
  globalAGGridCellStyle,
  globalAGGridCellStyle1,
} from 'src/app/shared/constants/globalStyles';
import { TransactionDetailRendererComponent } from '../../../partners/renderers/transaction-detail-renderer/transaction-detail-renderer.component';
import { LrcTypeRendererComponent } from '../../renderer/lrc-type-renderer/lrc-type-renderer.component';
import { LrcBenefRendererComponent } from '../../renderer/lrc-benef-renderer/lrc-benef-renderer.component';
import { LrcStatusesRendererComponent } from '../../renderer/lrc-statuses-renderer/lrc-statuses-renderer.component';
import { ComplianceBetaFiltersComponent } from 'src/app/pages/compliance-beta/components/compliance-beta-filters/compliance-beta-filters.component';
import { LrcTypeValueRendererComponent } from '../../renderer/lrc-type-value-renderer/lrc-type-value-renderer.component';
import { LrcWalletsRendererComponent } from '../../renderer/lrc-wallets-renderer/lrc-wallets-renderer.component';
import { SenderRendererComponent } from '../../renderer/sender-renderer/sender-renderer.component';
import { UserService } from 'src/app/shared/services';

@Component({
  selector: 'app-lrc-ag-grid',
  templateUrl: './lrc-ag-grid.component.html',
  styleUrls: ['./lrc-ag-grid.component.scss'],
})
export class LrcAgGridComponent implements OnInit {
  private gridApi!: GridApi<any>;
  public gridColumnApi: any = {};

  tableColumns: any[] = [];
  tableFilters: any[] = [];

  public user: any;

  isShowSender?: boolean;

  @Input() params: HttpParams | undefined;
  @Input() tableDataListItems: any[] = [];
  @Input() pageLimit?: number;
  @Input() page?: number;
  @Input() totalElements?: number;
  @Input() hasMore?: boolean;

  @Output() onPageLimitChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() onPageChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() onColumnFilterChanged: EventEmitter<any> = new EventEmitter<any>();

  constructor(private datePipe: DatePipe, public userService: UserService) {}

  ngOnInit(): void {
    this.setTableConfigurationByLanguage();

    this.user = this.userService.user;
  }

  showSender() {
    // console.log('user?.partner?.type: ', this.user?.partner?.type);

    console.log('partner?.type: ', this.user);

    if (this.user?.partner?.type !== 'ngo') {
      this.isShowSender = true;
    } else {
      this.isShowSender = false;
    }
  }

  setTableConfigurationByLanguage(): void {
    this.tableColumns = [
      {
        field: 'ref',
        headerName: 'REF',
        width: 280,
        cellStyle: globalAGGridCellStyle1,
      },
      {
        field: 'type',
        headerName: 'TYPE',
        width: 250,
        filter: true,
        floatingFilter: true,
        floatingFilterComponent: LrcTypeRendererComponent,
        floatingFilterComponentParams: {
          suppressFilterButton: true,
          filter: 'type',
          onSearchEvent: (event: any) => {
            this.onSearchInputChanged(event);
          },
        },
        cellRendererSelector: (params: ICellRendererParams<any>) => {
          return {
            component: LrcTypeValueRendererComponent,
            params: {
              ...params,
              httpParams: this.params,
            },
          };
        },
        cellStyle: globalAGGridCellStyle,
      },
      {
        field: 'beneficiary',
        headerName: 'BENEFICIARY NAME',
        width: 200,
        cellRendererSelector: (params: ICellRendererParams<any>) => {
          return {
            component: LrcBenefRendererComponent,
            params: {
              ...params,
              httpParams: this.params,
            },
          };
        },
        cellStyle: globalAGGridCellStyle,
      },
      {
        field: 'status',
        headerName: 'STATUS',
        width: 150,
        filter: true,
        floatingFilter: true,
        floatingFilterComponent: LrcStatusesRendererComponent,
        floatingFilterComponentParams: {
          suppressFilterButton: true,
          filter: 'transaction_status',
          onSearchEvent: (event: any) => {
            this.onSearchInputChanged(event);
          },
        },
        cellStyle: globalAGGridCellStyle,
      },
      {
        field: 'datetime_updated',
        headerName: 'STATUS DATE',
        width: 220,
        valueFormatter: (obj: any) => {
          if (obj?.value) {
            return this.datePipe.transform(obj.value, 'medium');
          } else {
            return 'N/A';
          }
        },
        cellStyle: globalAGGridCellStyle,
      },
      {
        field: 'amount',
        headerName: 'AMOUNT',
        width: 170,
        cellStyle: globalAGGridCellStyle,
      },
      {
        field: 'wallet_type',
        headerName: 'WALLET TYPE',
        width: 250,
        filter: true,
        floatingFilter: true,
        floatingFilterComponent: LrcWalletsRendererComponent,
        floatingFilterComponentParams: {
          suppressFilterButton: true,
          filter: 'wallet_type_id',
          onSearchEvent: (event: any) => {
            this.onSearchInputChanged(event);
          },
        },
        cellStyle: globalAGGridCellStyle,
      },
      {
        field: 'sender_receiver_relationship',
        headerName: 'SENDER RELATION',
        width: 170,
        filter: true,
        floatingFilter: true,
        floatingFilterComponent: ComplianceBetaFiltersComponent,
        floatingFilterComponentParams: {
          suppressFilterButton: true,
          filter: 'sender_relation__icontains',
          onSearchEvent: (event: any) => {
            this.onSearchInputChanged(event);
          },
        },
        cellStyle: globalAGGridCellStyle,
      },
      {
        field: 'purpose',
        headerName: 'TRANSFER REASON',
        width: 170,
        filter: true,
        floatingFilter: true,
        floatingFilterComponent: ComplianceBetaFiltersComponent,
        floatingFilterComponentParams: {
          suppressFilterButton: true,
          filter: 'transfer_reason__icontains',
          onSearchEvent: (event: any) => {
            this.onSearchInputChanged(event);
          },
        },
        cellStyle: globalAGGridCellStyle,
      },
      {
        field: 'lrc',
        headerName: 'ACTION',
        width: 200,
        cellStyle: globalAGGridCellStyle,
        cellRendererSelector: (params: ICellRendererParams<any>) => {
          return {
            component: TransactionDetailRendererComponent,
            params: {
              ...params,
              httpParams: this.params,
            },
          };
        },
      },
    ];
  }

  onGridReady(params: GridReadyEvent<any>) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    if (!isEmpty(this.tableDataListItems)) {
      this.gridApi.setRowData(this.tableDataListItems);
    }
  }

  onSearchInputChanged(event: { filter: string; value: string }) {
    const appIndex = this.tableFilters.findIndex(
      (i) => i.field === event.filter
    );

    if (appIndex === -1) {
      this.tableFilters.push({
        field: event.filter,
        search: event.value,
      });
    } else {
      this.tableFilters[appIndex].field = event.filter;
      this.tableFilters[appIndex].search = event.value;
    }

    this.onColumnFilterChanged.emit(this.tableFilters);
  }
}
